<template>
    <div v-if="user">
        <hr/>
        <div class="row">
            <div class="col-md-6 mb-4">
                <customer-purchases :user="user"></customer-purchases>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 mb-4">
                <div class="box">
                    <customer-survey-answers :user="user"></customer-survey-answers>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import { PurchaseClient } from '@/services/Services';
import { LocalizationServices } from '@/services/LocalizationServices';
import { ModalServices } from '@/services/ModalServices';
import { Prop } from 'vue-property-decorator';
import qualification from '@/components/user/components/qualification.vue';
import newFoodPlanFromDefaultsModal from './newFoodPlanFromDefaultsModal.vue';
import customerPurchases from './customerPurchases.vue';

@Options({
    components: {
        qualification,
        customerPurchases
    }
})
export default class customerData extends Vue {
 
    @Prop() user: OM.Lead;

    foodPlanVouchers: OM.FoodPlanVoucher[] = [];
    purchases: OM.Purchase[] = [];

    created(){
        this.init();
    }

    init(){
        PurchaseClient.getByCliente(this.user.identifier, true).then(x => this.purchases = x);
    }

    get isDottoreOfUser(){
        if(!this.user.professionistiAssegnati)
            return false;
        return this.user.professionistiAssegnati.some(x => x.user && x.user.identifier == this.$store.state.user.identifier);
    }

    
}

</script>
